export default __webpack_public_path__ + "static/media/ed2mit2021tuto01.02_gdpr-personal-data-v03.03c41345.pdf";